<script>
import { getCategoryList } from '../api'
export default {
  data() {
    return {
      categories: [],
    }
  },
  async created() {
    await this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await getCategoryList()
        this.categories = this.restructureCategories(res)
      } catch (error) {
        console.log('Error fetching categories:', error)
        this.$message.error('無法取得分類列表，請稍後再試 ')
      }
    },
    restructureCategories(categories) {
      return categories.map((parentCategory) => ({
        ...parentCategory,
        checked: true,
        expanded: true,
        children: parentCategory.children ? parentCategory.children.map((sub) => ({ ...sub, checked: true })) : [],
      }))
    },
    cleanFlattedCategory(categories) {
      let result = []

      // 將物件轉為陣列（排除非物件欄位）
      const items = Object.values(categories).filter((item) => item && typeof item === 'object')
      for (const item of items) {
        const { checked, children, expanded, ...rest } = item

        // 1. 遞迴處理子層
        let checkedChildren = []
        if (children && children.length > 0) {
          checkedChildren = this.cleanFlattedCategory(children)
        }

        // 2. 判斷匯出邏輯
        if (checkedChildren.length > 0) {
          // 只要子層有任何東西被勾選，就匯出子層（達到扁平化）
          result = result.concat(checkedChildren)
        } else if (checked === true) {
          // 如果子層都沒人勾，但父層自己有勾，匯出父層
          result.push(rest)
        }
      }

      return result
    },
    toggleExpand(category) {
      category.expanded = !category.expanded
    },
    toggleCategory(category) {
      const newState = !category.checked
      category.checked = newState
      category.children.forEach((sub) => (sub.checked = newState))
    },
    handleCategoryChange(category, val) {
      category.children.forEach((sub) => (sub.checked = val))
    },
    handleSubCategoryChange(category) {
      const allChecked = category.children.every((sub) => sub.checked)
      const someChecked = category.children.some((sub) => sub.checked)

      if (allChecked) {
        category.checked = true
      } else if (someChecked) {
        category.checked = false
      } else {
        category.checked = false
      }
    },
    async validateForm() {
      if (this.getStepData().length === 0) {
        this.$message.error('請至少選擇一個分類')
        return false
      }
      return true
    },
    getStepData() {
      return this.cleanFlattedCategory(this.categories)
    },
  },
}
</script>
<template>
  <div class="step-classification">
    <div class="header-guide">
      <div class="title">
        選擇房型適用分類
        <!-- <el-tooltip content="說明文字" placement="top">
          <i class="el-icon-warning-outline"></i>
        </el-tooltip> -->
      </div>
    </div>

    <div class="category-list">
      <div v-for="category in categories" :key="category.id" class="category-item" :style="category.checked ? {} : { borderColor: '#E5E7EB' }">
        <!-- Parent Category Header -->
        <div class="category-header" :class="{ expanded: category.expanded }">
          <div class="left" @click="toggleExpand(category)">
            <i :class="category.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
            <span class="category-name">{{ category.categoryTitle }}</span>
          </div>
          <div class="right">
            <el-checkbox v-model="category.checked" @change="(val) => handleCategoryChange(category, val)"></el-checkbox>
          </div>
        </div>

        <!-- Subcategories List -->
        <div v-show="category.expanded" class="subcategory-list">
          <div v-for="sub in category.children" :key="sub.id" class="subcategory-item" :style="sub.checked ? {} : { borderColor: '#BEC4C6' }">
            <span class="subcategory-name">{{ sub.categoryTitle }}</span>
            <el-checkbox v-model="sub.checked" @change="handleSubCategoryChange(category)"></el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.step-classification {
  padding: 20px;
}

.header-guide {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      color: #f37736;
    }
  }

  .action-link {
    color: #f56c6c;
    cursor: pointer;
    font-size: 14px;
  }
}

.category-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.category-item {
  border: 2px solid #f37736;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  background-color: #fff;

  .left {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    color: #333;
  }
}

.subcategory-list {
  padding: 0 15px 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.subcategory-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border: 1px solid #f37736;
  border-radius: 8px;
  background-color: #fff;
  color: #606266;
  margin-left: 30px;
}
</style>
